import React from 'react'
import { useEffect, useCallback, useMemo, useRequest, useTranslation } from '@hooks'
import { Title, Text, Popconfirm, Button } from '@components'

import { message } from 'antd'
import { TUser } from 'src/typings/profile'
import { ButtonType } from 'antd/lib/button'
import { api } from '@services'

const RemoveCommentLink: React.FC<TProps> = ({ commentId, buttonType = 'default', onSuccess }) => {
	const { t } = useTranslation()
	// Remove user.
	const { fetch: removeUser, fetching: removing } = useRequest<void, any>({
		request: () => api.deleteComment(commentId),
		onSuccess: () => onSuccess?.(),
		onError: (error) => message.error(error.message),
	})
	return (
		<Popconfirm title={t('Are you sure?')} okText={t('Yes')} cancelText={t('No')} onConfirm={removeUser}>
			<Button loading={removing} danger type={buttonType}>
				{t('Remove')}
			</Button>
		</Popconfirm>
	)
}

type TProps = {
	/** Id of terget user.  */
	commentId: TUser['id']
	/** Callback called after successful removing. */
	onSuccess: (props?: any) => void
	/** Type of button link */
	buttonType?: ButtonType
}

export default RemoveCommentLink
